import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/26_blossom/26_blossom"
 * Contains 1 texture(s)
 */
export class Tablet26BlossomAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/26_blossom/26_blossom';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '26_blossom.jpg'
    ] as const;
}
